import {
  Group,
  LabelMenuButton,
  Menu,
  MenuContent,
  MenuTrigger,
  Select,
  SelectContent,
  SelectTrigger,
} from '@optiaxiom/react';

import type { NotificationStatusFilter, NotificationViewMode } from '../types';

type Agent = {
  id: string;
  name: string;
};

type NotificationFilterBarProps = {
  status: NotificationStatusFilter;
  agentId: string | undefined;
  // kept for future view-toggle re-introduction
  view: NotificationViewMode;
  agents: Agent[];
  onStatusChange: (status: NotificationStatusFilter) => void;
  onAgentChange: (agentId: string | undefined) => void;
  // kept for future view-toggle re-introduction
  onViewChange: (view: NotificationViewMode) => void;
};

const STATUS_OPTIONS: Array<{ label: string; value: NotificationStatusFilter }> = [
  { label: 'All', value: 'all' },
  { label: 'Read', value: 'read' },
  { label: 'Unread', value: 'unread' },
];

export function NotificationFilterBar({
  status,
  agentId,
  agents,
  onStatusChange,
  onAgentChange,
}: NotificationFilterBarProps) {
  const statusMenuOptions = STATUS_OPTIONS.map(opt => ({
    label: opt.label,
    selected: status === opt.value,
    execute: () => onStatusChange(opt.value),
  }));

  const agentSelectOptions = [
    { label: 'All Agents', value: '' },
    ...agents.map(agent => ({ label: agent.name, value: agent.id })),
  ];

  const statusLabel = STATUS_OPTIONS.find(o => o.value === status)?.label || 'All';
  const agentLabel = agents.find(a => a.id === agentId)?.name || 'All Agents';

  return (
    <Group justifyContent="space-between">
      <Group gap="8">
        <Menu options={statusMenuOptions}>
          <MenuTrigger asChild>
            <LabelMenuButton label="Status">{statusLabel}</LabelMenuButton>
          </MenuTrigger>
          <MenuContent />
        </Menu>

        <Select
          options={agentSelectOptions}
          value={agentId || ''}
          onValueChange={value => onAgentChange(value || undefined)}
        >
          <SelectTrigger asChild>
            <LabelMenuButton label="Agent">{agentLabel}</LabelMenuButton>
          </SelectTrigger>
          <SelectContent />
        </Select>
      </Group>
    </Group>
  );
}
